"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormPopup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const ContactFormAnalyticsService_1 = require("./ContactFormAnalyticsService");
const dialog_1 = require("../ModalDialog/dialog");
const initialContactFormPopupState = {
    isSpinnerVisible: true,
    submitted: false,
    error: false,
    formLoadFailed: false,
};
const ContactFormPopup = ({ isOpened = true, formAlias, formTitle, clearFormStateOnModalExited, popupOpenedAriaLabel, closeButtonAriaLabel, onPopupClose = () => undefined, onModalExited, children, popupRenderId = app_1.DateService.getTimestamp(), }) => {
    const [contactFormState, setContactFormState] = React.useState(initialContactFormPopupState);
    const handleOnClose = React.useCallback(() => {
        const { formLoadFailed, submitted } = contactFormState;
        onPopupClose();
        if (!submitted && !formLoadFailed) {
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormAbandon(formAlias, formTitle);
        }
    }, [contactFormState, formAlias, formTitle, onPopupClose]);
    const extraClasses = React.useMemo(() => (contactFormState.submitted ? 'contact-form-popup__submit-result' : ''), [contactFormState.submitted]);
    const handleOnModalExited = React.useCallback(() => {
        if (onModalExited) {
            onModalExited();
        }
        if (clearFormStateOnModalExited) {
            setContactFormState(initialContactFormPopupState);
        }
    }, [clearFormStateOnModalExited, onModalExited]);
    return ((0, jsx_runtime_1.jsx)(dialog_1.Dialog, { title: contactFormState.formLoadFailed ? '' : formTitle, isOpen: isOpened, onClose: handleOnClose, onModalExited: handleOnModalExited, reactDOMRenderId: popupRenderId, classes: `contact-form-popup group ${extraClasses}`, addClosePropertyForChildren: false, popupAriaLabel: popupOpenedAriaLabel, closeButtonAriaLabel: closeButtonAriaLabel, backdrop: "static", keyboard: true, children: children(contactFormState, setContactFormState) }));
};
exports.ContactFormPopup = ContactFormPopup;
exports.default = exports.ContactFormPopup;
